import styled from "styled-components";

export const FaqsWrapper = styled.section`
  background-color: var(--white);
  transition: all 0.3s ease-in-out;
  .item-wrapper {
    padding-right: 15px;
  }
  .item-container {
    padding: 0;
    margin: 8px 0;
    border: 1px solid #eaedf3;
    cursor: pointer;
    border-radius: 12px;
    background-color: #f7f9fb;
  }
  /* @media (max-width: 570px) {
    margin: 8px 15px;
  } */
  .sliderWrapper {
    padding: 0 100px;
    @media (max-width: 1200px) {
      padding: 0 0;
    }
  }
  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    .item-box-heading {
      color: var(--text);
      font-weight: 700;
      font-size: 20px;
    }
    .item-box-text {
      color: var(--text4);
      font-size: 20px;
      margin: 0;
      padding: 20px 20px 20px 20px;
    }
    & .active {
      border-bottom: 1px solid #e4e8eb;
    }
    & > svg {
      width: 16px;
      height: 16px;
    }
  }

  .active-item-box {
    .item-box-heading {
      /* padding-bottom: 10px; */
    }
    .item-box-text {
      color: var(--text);
      font-size: 16px;
      margin: 0;
      padding: 20px 20px 20px 20px;
    }
    & .border-bottom-line {
      border-bottom: 1px solid #eaedf3;
    }
    & > .item-box {
      position: relative;
    }
  }
  @media (max-width: 991px) {
    padding-top: 10px;
  }
`;
